import { render } from "./BaseFooter.vue?vue&type=template&id=100d8044&scoped=true&ts=true"
import script from "./BaseFooter.vue?vue&type=script&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=100d8044&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100d8044"]])

export default __exports__